import { Controller } from "@hotwired/stimulus"

// Auto-save Event "notes" field
export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 2000 }
  }

  connect() {
    this.timeout = null
  }

  save() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.submit()
    }, this.delayValue)
  }

  submit() {
    const token = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        notes: this.element.value
      })
    })
  }
}